import { jsx as e } from "@emotion/react/jsx-runtime";
import { Tooltip as I } from "../Tooltip/index.js";
import { StyledOutlinedIconButton as p, StyledContainedIconButton as x, OverrideIcon as O, sizes as h } from "./appearance/core.styled.js";
const B = {
  contained: {
    button: x
  },
  outlined: {
    button: p
  }
}, z = ({
  dataTrackId: i,
  icon: c,
  appearance: n = "contained",
  variant: o = "default",
  size: l = "medium",
  disabled: t = !1,
  tooltip: r,
  tooltipPlacement: d = "auto",
  caret: u = !0,
  zIndex: a,
  onClick: m,
  "aria-label": b,
  "aria-labelledby": f,
  ref: s,
  ...S
}) => {
  const y = o === "default" || o === "white" && n === "contained" ? "secondary" : o, C = B[n].button;
  return /* @__PURE__ */ e(I, { text: r, zIndex: a, caret: u, placement: d, children: /* @__PURE__ */ e(C, { ...S, ref: s, onClick: t ? void 0 : m, "data-track": i, appearance: n, variant: o, disabled: t, "aria-disabled": t, "aria-label": b, "aria-labelledby": f, size: l, as: "button", children: /* @__PURE__ */ e(O, { icon: c, disabled: t, iconSize: `${h[l].fontSize}px`, color: y }) }) });
};
export {
  z as IconButton
};
